
import { motion } from "framer-motion";
import { Link } from "wouter";

export default function Sitemap() {
  const sitePages = [
    { name: 'Home', path: '/', description: 'Main page with hero section, about, services overview' },
    { name: 'Gallery', path: '/gallery', description: 'Complete portfolio of our welding projects' },
    { name: 'Login/Register', path: '/auth', description: 'User authentication page' },
  ];

  const siteServices = [
    'Custom Railings',
    'Structural Welding', 
    'Repair & Restoration',
    'Custom Fabrication',
    'Residential Services',
    'Commercial Projects'
  ];

  const serviceAreas = [
    'Ridgefield, CT', 'Danbury, CT', 'Wilton, CT', 'Redding, CT',
    'Weston, CT', 'Norwalk, CT', 'Westport, CT', 'Bethel, CT',
    'New Canaan, CT', 'Greenwich, CT', 'Stamford, CT', 'Darien, CT',
    'Fairfield, CT', 'Bridgeport, CT', 'Trumbull, CT'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-black text-white">
      {/* Header */}
      <header className="bg-black/20 backdrop-blur-sm border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link href="/" className="text-2xl font-bold text-red-600">
              Swiss Welding LLC
            </Link>
            <Link href="/" className="text-gray-300 hover:text-white transition-colors">
              ← Back to Home
            </Link>
          </div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold mb-8 text-center">Site Map</h1>
          <p className="text-gray-400 text-center mb-12 max-w-2xl mx-auto">
            Navigate through all pages and sections of Swiss Welding LLC website
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Main Pages */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-zinc-800/50 p-6 rounded-lg border border-gray-700"
            >
              <h2 className="text-xl font-semibold mb-4 text-red-400">Main Pages</h2>
              <ul className="space-y-3">
                {sitePages.map((page, index) => (
                  <li key={index}>
                    <Link 
                      href={page.path}
                      className="text-blue-400 hover:text-blue-300 transition-colors font-medium block"
                    >
                      {page.name}
                    </Link>
                    <p className="text-sm text-gray-400 mt-1">{page.description}</p>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Services */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-zinc-800/50 p-6 rounded-lg border border-gray-700"
            >
              <h2 className="text-xl font-semibold mb-4 text-red-400">Our Services</h2>
              <ul className="space-y-2">
                {siteServices.map((service, index) => (
                  <li key={index} className="text-gray-300">
                    • {service}
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Service Areas */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="bg-zinc-800/50 p-6 rounded-lg border border-gray-700"
            >
              <h2 className="text-xl font-semibold mb-4 text-red-400">Service Areas</h2>
              <div className="space-y-1 text-sm">
                {serviceAreas.map((area, index) => (
                  <div key={index} className="text-gray-300">
                    {area}
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 bg-zinc-800/50 p-8 rounded-lg border border-gray-700 text-center"
          >
            <h2 className="text-2xl font-semibold mb-4 text-red-400">Contact Information</h2>
            <div className="grid md:grid-cols-3 gap-6 text-gray-300">
              <div>
                <h3 className="font-medium mb-2">Phone</h3>
                <a href="tel:+12035441097" className="text-blue-400 hover:text-blue-300 transition-colors">
                  (203) 544-1097
                </a>
              </div>
              <div>
                <h3 className="font-medium mb-2">Email</h3>
                <a href="mailto:customerservice@swissweldingllc.com" className="text-blue-400 hover:text-blue-300 transition-colors">
                  customerservice@swissweldingllc.com
                </a>
              </div>
              <div>
                <h3 className="font-medium mb-2">Location</h3>
                <p>Ridgefield, CT & Surrounding Areas</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
